import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, user, requireAdmin = false, allowedRoles = [] }) => {
  if (!user) {
    return <Navigate to="/login" />;
  }

  if (requireAdmin && user.role !== 'admin') {
    // Redirect to dashboard with error message in URL params
    return <Navigate to="/?error=access_denied" />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    // Redirect to dashboard with error message in URL params
    return <Navigate to="/?error=access_denied" />;
  }

  return children;
};

export default ProtectedRoute;